/* eslint-disable @typescript-eslint/no-unused-vars */
import dayjs from 'dayjs';

const DATE_TWITTER_API_MIGRATION =
    process.env.NEXT_PUBLIC_ENV === 'staging'
        ? '2023-04-26T00:00:00.000000Z'
        : '2023-04-29T00:00:00.000000Z';

const useTwitterProfile = () => {
    const isTwitterProfileCreatedAfterMigration = (createdAt: string) => {
        // return dayjs(createdAt).utc().isAfter(dayjs(DATE_TWITTER_API_MIGRATION).utc());
        return false;
    };

    return { isTwitterProfileCreatedAfterMigration };
};

export default useTwitterProfile;
